import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import PrintIcon from "@material-ui/icons/Print";
import GetAppIcon from "@material-ui/icons/GetApp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import moment from "moment-timezone";
import Pagination from "../Pagination/Pagination";
import useDocFormsStore from "../../store/docFormsStore";
import iconFolderYellow from "../../../../Assets/templateV2/folder_yellow.svg";
import { useAssignedForms } from "../../hooks/useAssignedForms";
import PDFViewerModal from "../PDFViewerModal/PDFViewerModal";

const useStyles = makeStyles((theme) => ({
	container: {
		backgroundColor: "#fff",
		padding: "14px 16px",
		height: "100%",
		flex: 1,
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
	},
	actionText: {
		fontSize: "14px",
		marginLeft: "4px",
		color: "#006ac6",
	},
	tableContainer: {
		marginBottom: "16px",
	},
	table: {
		minWidth: 650,
	},
	tableHeader: {
		backgroundColor: theme.palette.grey[100],
	},
	tableCell: {
		padding: "12px 16px",
	},
	iconCell: {
		width: "40px",
		padding: "8px",
	},
	icon: {
		width: "24px",
		height: "24px",
	},
}));

export default function CompletedView({ setLoading }) {
	const classes = useStyles();
	const [currentPage, setCurrentPage] = useState(1);
	const [templatesPerPage] = useState(10);
	const [selectedPdf, setSelectedPdf] = useState(null);

	// Get completed forms from Zustand store
	const completedForms = useDocFormsStore((state) => state.completedForms);
	const { getAssignedFormsFilteredByCompleted } = useAssignedForms();
	useEffect(() => {
		getAssignedFormsFilteredByCompleted();
	}, []);
	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
	};

	const openViewDocument = (row) => {
		setSelectedPdf(row.pdfUrl);
	};

	const handleClosePdfViewer = () => {
		setSelectedPdf(null);
	};

	const columns = [
		{
			field: "templateName",
			headerName: "Document Name",
			flex: 1.5,
		},
		{
			field: "requestedAt",
			headerName: "Request Date",
			flex: 1,
			
		},
		{
			field: "completed",
			headerName: "Completed",
			flex: 0.8,
			valueGetter: (params) => {
				return params.row.completed ? "Yes" : "No";
			},
		},
		{
			field: "templateId",
			headerName: "Template ID",
			flex: 1,
			valueGetter: (params) => {
				return "-";
			},
		},
		{
			field: "actions",
			headerName: "Actions",
			flex: 1,
			renderCell: (params) => {
				return (
					<div style={{ display: "flex", gap: "10px" }}>
						<IconButton color="primary" onClick={() => openViewDocument(params.row)}>
							<VisibilityIcon style={{ color: "#006ac6" }} />
							<span className={classes.actionText}>View</span>
						</IconButton>
					</div>
				);
			},
		},
	];

	// Add unique IDs to rows if they don't exist
	const rowsWithIds = completedForms.map((form, index) => ({
		...form,
		id: form.id || `completed-${index}`,
	}));

	return (
		<div className={classes.container}>
			<DataGrid
				rows={rowsWithIds}
				columns={columns}
				pageSize={10}
				rowsPerPageOptions={[10]}
				disableSelectionOnClick
				autoHeight
				sx={{
					"& .MuiDataGrid-columnHeaders": {
						backgroundColor: "#006ac6",
						color: "white",
					},
				}}
			/>
			<Pagination
				currentPage={currentPage}
				itemsPerPage={templatesPerPage}
				totalItems={completedForms.length}
				onPageChange={handlePageChange}
			/>
			<PDFViewerModal
				open={!!selectedPdf}
				onClose={handleClosePdfViewer}
				pdfUrl={selectedPdf}
			/>
		</div>
	);
}
